export default {
      id: "close-usage",
      viewBox: "0 0 409.806 409.806",
      url: __webpack_public_path__ + "app/svg/sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }